import React from 'react';
import { List, ListItem } from 'material-ui/List';
import FlatButton from 'material-ui/FlatButton';
import CommunicationCallMerge from 'material-ui/svg-icons/communication/call-merge';
import Avatar from 'material-ui/Avatar';
import Dialog from 'material-ui/Dialog';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';
import NavigationMoreVert from 'material-ui/svg-icons/navigation/more-vert';
import { Map } from 'immutable';

const colors = ['#F44336', '#00BCD4', '#FF5722', '#795548', '#4CAF50', '#9C27B0'];

function NewCollectiveResults({ results, collectives, onMergeRequest, handleEdit }) {

  function collective(id) {
    return collectives.get('items').get(id.toString()) || Map();
  };

  return (
    <div>
      <h3 style={{ fontWeight: 400 }}>The following collectives were created during import.</h3>
      <Divider />
      <List>
        {results.map(id =>
          <ListItem
            key={id}
            leftAvatar={collective(id).get('name') &&
              <Avatar
                size={50}
                style={{
                  backgroundColor: colors[id % colors.length],
                }}
              >
                {collective(id).get('name').charAt(0)}
              </Avatar>
            }
            primaryText={collective(id).get('name')}
            secondaryText={`Influencers: ${collective(id).get('influencersCount')}`}
            rightIconButton={
              <IconMenu
                iconButtonElement={<IconButton><NavigationMoreVert /></IconButton>}
                anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                targetOrigin={{ horizontal: 'right', vertical: 'top' }}
              >
                <MenuItem
                  primaryText="Edit"
                  onTouchTap={handleEdit.bind(this, id)}
                />
                <MenuItem
                  primaryText="Merge"
                  onTouchTap={onMergeRequest.bind(this, id)}
                />
                <MenuItem
                  primaryText="Cancel"
                  onTouchTap={null}
                />
              </IconMenu>
            }
          />
        )}
      </List>
    </div>
  );
}

export default NewCollectiveResults;



/** WEBPACK FOOTER **
 ** ./components/NewCollectiveResults.js
 **/